// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Element from 'element-ui'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store'
import MessageBox from './components/message-box/message-box'
Vue.config.productionTip = false

Vue.use(Element)
Vue.use(MessageBox)
Vue.use(mavonEditor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  mounted () {
    // 初始化应用数据
    this.$store.dispatch('initAppInfo')
  }
})



// WEBPACK FOOTER //
// ./src/main.js